import { Button, Text } from "@RooUI";
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import { getIsFromEvent } from "../../../Common/queryParamsUtils";
import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";
import { ButtonContainer } from "../RegistrationPageContainer/styles";

import { useOnClickHireflix } from "./service";
import { Container } from "./styles";

const RegistrationHireflix = () => {
  const { redirectToEducation } = useRedirect();
  const {
    registrationContext: { userId, entityId },
  } = useRegistrationContext();
  const { onClick } = useOnClickHireflix({ userId, entityId });
  const isFromEvent = getIsFromEvent(window.location.search);

  useEffect(() => {
    EventTracker.send({
      eventName: Event.Name.TECH_VIEW_HIREFLIX,
      eventType: Event.Type.CLICK,
      entityType: Event.Entity.TECH,
      entityId: entityId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegistrationPageContainer
      title="One-sided Virtual Interview"
      hideProgressBar
      // @ts-expect-error TS2322
      linkProps={
        !isFromEvent && {
          children: `Back to Education`,
          onClick: redirectToEducation,
        }
      }
    >
      <Container>
        <Text>
          We’d love to get to know you better. Please use the button below to book a time for us to
          connect and learn more about you and your needs.
        </Text>
        <ButtonContainer>
          <Button $buttonType="primary" title="Go to Hireflix" onClick={onClick} />
        </ButtonContainer>
      </Container>
    </RegistrationPageContainer>
  );
};

// eslint-disable-next-line no-restricted-exports
export default withRouter(RegistrationHireflix);
